import * as React from "react";

function SvgRightOpen(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 14 24"
      focusable={false}
      role="presentation"
      aria-hidden={true}
      {...props}
    >
      <path d="M4.03.65c.86.85 9.27 9.72 9.27 9.72a2.27 2.27 0 010 3.26s-8.4 8.87-9.27 9.71a2.43 2.43 0 01-3.33 0 2.2 2.2 0 010-3.25L8.43 12 .71 3.92a2.22 2.22 0 010-3.27 2.45 2.45 0 013.32 0z" />
    </svg>
  );
}

const MemoSvgRightOpen = React.memo(SvgRightOpen);
export default MemoSvgRightOpen;
